import React from "react";

// Reusable responsive (16:9) intro video card. Pass a Dubb (or any) embed URL.
export default function IntroVideo({ title, subtitle, embedUrl, testid = "intro-video", paddingBottom = "56.25%" }) {
  return (
    <div data-testid={testid} className="rounded-2xl border border-[#E5E2DC] bg-white p-5">
      <h3 className="font-head text-lg font-semibold text-neutral-900">{title}</h3>
      {subtitle && <p className="mt-1 text-sm text-neutral-500">{subtitle}</p>}
      <div className="mt-4 overflow-hidden rounded-xl" style={{ position: "relative", height: 0, paddingBottom }}>
        <iframe
          title={title}
          loading="lazy"
          src={embedUrl}
          style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }}
          allow="autoplay; encrypted-media; picture-in-picture"
          frameBorder="0"
          allowFullScreen
        />
      </div>
    </div>
  );
}
